/* eslint-disable @typescript-eslint/naming-convention */
import { ADDRESS_TYPE_ID } from '../../../constants/Constants';
import Address, { IAddressAttributes } from '../../../domain/entities/Address';
import { IAddressResponse } from '../../IApiResponses';

const addressMapper = {
  response(address: IAddressResponse): IAddressAttributes {
    const {
      address_type,
      bad_fields,
      city,
      colony,
      company_name,
      country,
      country_id,
      created_date,
      default_shipping,
      delivery_instructions,
      address5,
      address1,
      address4,
      address_id,
      phone1,
      phone1_type,
      address2,
      phone2,
      phone2_type,
      state,
      address3,
      updated_date,
      postal_code,
      municipality,
      country_label,
      ...rest
    } = address;
  
    // TODO: Update addressinfosearch API normalizing field names, then remove all the address1...5 fields mapping when RCO-9875 is done
    return {
      address1: address1 || address.firstLineAddress || '',
      address2: address2 || address.secondLineAddress || '',
      address3: address3 || address.thirdLineAddress || '',
      address4: address4 || address.fourthLineAddress || '',
      address5: address5 || address.fifthLineAddress || '',
      address_id: (address_id && address_id.toString()) || Address.NEW_ADDRESS_ID,
      address_type: address_type || ADDRESS_TYPE_ID.SHIPPING,
      bad_fields: bad_fields || [],
      city: city || '',
      colony: colony || '',
      company_name: company_name || '',
      country: country_label ? country_label.label : '',
      country_id: country_id,
      created_date: created_date || '',
      default_shipping: !!default_shipping,
      delivery_instructions: delivery_instructions || '',
      municipality: municipality || '',
      phone1: phone1 ? phone1.replace(/-+/g, '') : '',
      phone1_type: phone1_type,
      phone2: phone2 || '',
      phone2_type: phone2_type,
      postal_code: postal_code?.toUpperCase() || '',
      state: state || '',
      updated_date: updated_date || '',
      ...rest,
    };
  },
};

export default addressMapper;